export enum ClickAdEventTarget {
  CloseButton = 'close_button',
  CloseClickOutsidePlacement = 'close_click_outside_placement',
  BackNavigationButton = 'close_back_nav',
  // TODO: Update name, once it will be updated in event definition
  OpenPromotions = 'opening_promotions',
  Creative = 'creative',
  Cta = 'cta',
  AdInfo = 'ad_info',
  SecondaryButton = 'secondary_button',
  PrivacyPolicy = 'privacy_policy',
}
